// GE 엔진 JS 를 붙이는 **인라인 로더**의 소스(#5837).
//
// GE 가 지정한 형태는 id 를 **바깥 인라인 로더**에 두고, 로더가 만든 엔진 `<script>` 에는 id 가
// 없다(docs/global-e-storefront.md §1.3 의 snippet):
//
//   <script id="globaleScript">            ← id 는 여기
//     (function () {
//       var s = document.createElement("script");   ← 엔진. id 없음
//       …
//       document.getElementsByTagName("head")[0].appendChild(s);
//     })();
//   </script>
//
// 종전 구현은 엔진 `<script src>` 자체에 id 를 붙였다 — GE 가 스크린샷으로 수정을 요청했다.
// 로더 자신은 `GlobalEScripts` 가 §1.3 사양대로 `</body>` 직전에 넣는다(엔진은 로더가 head 에).
// 스펙과 달라지는 것은 두 가지뿐이다:
//   · `src` 는 `//` 대신 `https://` 명시(§1.3 「Protocol 명시」 — localhost http 에서 404)
//   · onload/onerror 로그를 로더 안에 둔다 — 로더로 옮기면서 TS 쪽 핸들러가 사라지기 때문
export function buildGeLoaderSource(src: string): string {
  const quoted = JSON.stringify(src);
  return `(function () {
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = ${quoted};
  s.onload = function () { console.log("[GlobalE] JS loaded:", s.src); };
  s.onerror = function (e) { console.error("[GlobalE] JS load error:", s.src, e); };
  document.getElementsByTagName("head")[0].appendChild(s);
})();`;
}
